module.exports = __webpack_public_path__ + "media/dog-personality-traits/heart-d869bcb9.svg";